import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem, FilterChange } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { LoaderService } from 'app/shared/services/loader.service';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { BehaviorSubject } from 'rxjs';
import { auditTime, tap } from 'rxjs/operators';

@Component({
    selector: 'app-check-box-pagined',
    templateUrl: './check-box-pagined.component.html',
    styleUrls: ['./check-box-pagined.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckBoxPaginedComponent implements OnInit, AfterViewInit {
  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;

  @Input() filter: InternalFilterGroup;
  @Input() dataToView: FilterItem[] = [];
  @Input() loaderId: string;
  @Input() totalCount: number;

  @Input() searchSettings: SearchSettings = {
    placeholder: 'Search...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  @Output() search = new EventEmitter<string>();
  @Output() nextData = new EventEmitter<any>();
  @Output() change = new EventEmitter<FilterChange>();

  filterOptions = new BehaviorSubject<FilterItem[]>([]);

  CDK_HEIGHT: number = 200;
  CDK_ITEM: number = 30;
  ENDDATA_HEIGHT: number = 17;
  constructor(
    private loaderService: LoaderService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataToView) {
      if (this.filter.selected.length > 0) {
        this.filter.selected.forEach(item => {
          this.dataToView?.forEach(data => {
            if (item.value === data.value) {
              data.checked = true;
            }
          });
        });
      }
      this.filterOptions.next([...this.filterOptions.value, ...this.dataToView]);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.viewPort?.scrolledIndexChange.pipe(auditTime(300), tap(() => {
      if (this.filter.withPagination && this.totalCount > this.filterOptions.value.length) {
        this.nextBatch();
      }
    })).subscribe();
  }

  nextBatch() {
    const end = this.viewPort.getRenderedRange().end;
    const total = this.viewPort.getDataLength();
    if (end >= total) {
      this.nextData.emit(this.filterOptions.value.length);
    }
  }

  trackByIdx(i: number) {
    return i;
  }

  onChangeCheckBox(group: InternalFilterGroup, item: FilterItem) {
    item.checked = !item.checked;
    if (item.checked) {
      group.selected.push(item);
    } else {
      group.selected = group.selected.filter(i => i.value !== item.value);
    }
  }

  onSearch(search: string) {
    this.filterOptions.next([]);
    this.search.emit(search);
  }

}
